import { useContext, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { APIContext } from "context/APIContext"

import FullscreenLoading from "components/Loading/FullscreenLoading"
import KinesisProfile from 'views/Profile/KinesisProfile'
import KinesisProfileV5 from 'views/Profile/KinesisProfileV5'

export default function KinesisProfileRouter({ 
    propProfileType = 'individual' 
}) {

    const { urlGroupId, urlAthleteId } = useParams()

    const { GetKinesisUserGroupDetails, GetUserDetails } = useContext(APIContext)

    const [kinesisProfileDetails, setKinesisProfileDetails] = useState(null)

    const __InitializeGroupProfile = async () => {
        setKinesisProfileDetails(null)
        const groupDetails = await GetKinesisUserGroupDetails(urlGroupId)
        setKinesisProfileDetails(groupDetails)
    }
    
    const __InitializeIndividualProfile = async () => {
        setKinesisProfileDetails(null)
        const userDetails = await GetUserDetails(urlAthleteId)
        setKinesisProfileDetails(userDetails)
    }

    useEffect(() => {
        if (propProfileType === 'group') {
            __InitializeGroupProfile()
        }

        if (propProfileType === 'individual') {
            __InitializeIndividualProfile()
        }
    }, [propProfileType, urlGroupId, urlAthleteId])

    if (kinesisProfileDetails === null) {
        return <FullscreenLoading />
    }

    // GROUP KINESIS PROFILE

    if (propProfileType === 'group') {
        if (kinesisProfileDetails?.boilerplateEnabled === 0) {
            return (
                <KinesisProfile propProfileType={propProfileType} />
            )
        }

        if (kinesisProfileDetails?.boilerplateEnabled === 1) {
            return (
                <KinesisProfileV5 propProfileType={propProfileType} kinesisProfileDetails={kinesisProfileDetails} />
            )
        }
    }

    // INDIVIDUAL KINESIS PROFILE

    if (propProfileType === 'individual') {
        if (kinesisProfileDetails?.boilerplateEnabled === 0) {
            return (
                <KinesisProfile propProfileType={propProfileType} />
            )
        }

        if (kinesisProfileDetails?.boilerplateEnabled === 1) {
            return (
                <KinesisProfileV5 propProfileType={propProfileType} kinesisProfileDetails={kinesisProfileDetails} />
            )
        }
    }
}